export const link_linkdin = "https://www.linkedin.com/company/tinexta/";
export const link_youtube = "https://www.youtube.com/@tinexta8878";
